import { number } from "prop-types";
import { useState, useCallback } from "react";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useAddGracePeriod(props) {
  const { makeAuthedRequest, hasPermission } = Auth.useContainer();
  const { logError } = useLogger({ prefix: "useAddGracePeriod" });

  const [isWaiting, setIsWaiting] = useState(false);
  const [iboNumber, setIboNumber] = useState(0);
  const [graceAward, setGraceAward] = useState(0);
  const [newAward, setNewAward] = useState(0);
  const [periodStart, setPeriodStart] = useState();
  const [periodEnd, setPeriodEnd] = useState();
  const [yearsDiamondPlus, setYearsDiamonsPlus] = useState(1);
  const [notes, setNotes] = useState("");

  const submit = useCallback(async () => {
    setIsWaiting(true);

    const gracePeriod = JSON.stringify({
      iboNumber: Number(iboNumber),
      graceAward: Number(graceAward),
      newAward: Number(newAward),
      periodStart: periodStart,
      periodEnd: periodEnd,
      yearsDiamondPlus: yearsDiamondPlus,
      notes: notes.trim(),
    });

    const canCreate = hasPermission("membership.loa.plugins.create");
    if (canCreate) {
      return makeAuthedRequest(`/v1/membership/loa/graceperiod/`, {
        method: "POST",
        body: gracePeriod,
      })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const json = await res.json();
            throw new Error(json.message);
          }
        })
        .catch(logError)
        .finally(() => {
          setIsWaiting(false);
          props.onClose();
        });
    }
  }, [
    graceAward,
    newAward,
    notes,
    periodStart,
    periodEnd,
    hasPermission,
    props,
    yearsDiamondPlus,
    makeAuthedRequest,
    logError,
  ]);

  return {
    submit,
    isWaiting,

    iboNumber,
    setIboNumber,

    graceAward,
    setGraceAward,

    newAward,
    setNewAward,

    notes,
    setNotes,

    periodStart,
    setPeriodStart,

    periodEnd,
    setPeriodEnd,
  };
}
